export function getPathToInspections(
  organizationId: string | undefined,
  projectId: string | undefined,
) {
  return `/vortex/organizations/${organizationId}/sites/${projectId}/inspections`;
}

export function getPathToHome() {
  return '/vortex';
}
